module.exports = __webpack_public_path__ + "img/banner2.2477b870.jpg";